import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";
import bootstrapReact from './assets/images/bootstrap-react.png';
import bootstrapReact1 from './assets/images/bootstrap-react1.png';
import bootstrapReact2 from './assets/images/bootstrap-react2.png';
import bootstrapReact3 from './assets/images/bootstrap-react3.png';
import bootstrapReact4 from './assets/images/bootstrap-react4.png';
import bootstrapReact5 from './assets/images/bootstrap-react5.png';


const ReactLesson12 = () => {
    const [language, changeLanguage] = useState("react");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        

        
  
        `
      );
      const code1 = (
        'text',
        `
        import React from 'react';

        const App = () => {
            return (
                <div className="container">
                <h1 className="text-primary"> Hello, Bootstrap with React!</h1>
                <button className="btn btn-primary">Click Me</button>
                </div>
            );
        };

        export default App;


  
        `
      );
      const code2 = (
        'text',
        `
        yarn add bootstrap


  
        `
      );
  
      const code3 = (
        'text',
        `
        import React from 'react';
        import 'bootstrap/dist/css/bootstrap.mini.css';

        const App = () => {
            return (
                <div className="container">
                <h1 className="text-primary">Hello, Bootstrap with React!</h1>
                <button className="btn btn-primary">Click Me</button>
                </div>
            );
        };

        export default App;


  
        `
      );
      const code4 = (
        'text',
        `
        yarn add bootstrap


  
        `
      );

      const code5 = (
        'text',
        `
        import React from 'react';
        import { container, Button } from 'react-bootstrap';
        import 'bootstrap/dist/css/bootstrap.mini.css';

        const App = () => {
            return (
                <container>
                <h1 className="text-primary">Hello, Bootstrap with React!</h1>
                <button varient="primary">Click Me</button>
                </container>
            );
        };

        export default App;


  
        `
      );

  


  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">

    <h3><strong>What is Bootstrap?</strong></h3>
      <p>Bootstrap is a popular, open-source front-end framework developed by X (formerly Twitter). It provides a collection of tools, components, and stylesheets designed to help developers build responsive, mobile-first web applications more efficiently.</p>
      <h4 class="text-dark">Key Features of Bootstrap:</h4>
      <ol class="list-group list-group-numbered mb-4">
      <li  class="list-group-item"><strong>Responsive Grid System:</strong>
      <ol>
          <li>Bootstrap offers a responsive grid system based on a 12-column layout, making it easy to create responsive designs for various screen sizes.</li>
      </ol>
      </li>
      <li  class="list-group-item"><strong>Pre-styled Components:</strong>
      <ol>
          <li>It includes a wide range of pre-styled components like buttons, forms, navigation bars, cards, modals, carousels, and more, which can be easily customized and used in web development.</li>
      </ol>
      </li>
      <li  class="list-group-item"><strong>Customization:</strong>
      <ol>
          <li>Developers can customize Bootstrap by utilizing its variables and mixins or by using custom build tools to modify the framework's default settings.</li>
      </ol>
      </li>
      <li  class="list-group-item"><strong>CSS-based Design:</strong>
      <ol>
          <li>Bootstrap's core is built with CSS, utilizing classes and components to style the HTML elements.</li>
      </ol>
      </li>
      <li  class="list-group-item"><strong>Cross-browser Compatibility:</strong>
      <ol>
          <li>Bootstrap ensures consistent styling and functionality across different web browsers, improving compatibility.</li>
      </ol>
      </li>
      </ol>
      <h4><strong>Benefits of Using Bootstrap:</strong></h4>
      <ol class="list-group list-group-numbered">
      <li class="list-group-item"><strong>Faster Development:</strong> Bootstrap allows for quick prototyping and development by providing ready-to-use components and styles.</li>
      <li class="list-group-item"><strong>Consistency:</strong> Using Bootstrap ensures consistency in design and layout across various parts of the application.</li>
      <li class="list-group-item"><strong>Mobile-first Approach:</strong>Bootstrap follows a mobile-first approach, making it easier to create responsive and mobile-friendly websites.</li>
      <li class="list-group-item"><strong>Flexibility:</strong>While Bootstrap offers a lot out-of-the-box, it also allows for customization to fit specific project needs.</li>
      </ol>
      <p>We are not going to exhaustively cover Bootstrap here as they already have a robust documentation @ <strong class="text-primary">getbootstrap.com</strong></p>
      <p>Let us see how to integrate Bootstrap with React.</p>

      <h3><strong>Add Bootstrap to React</strong></h3>
      <p>Integrating React with Bootstrap allows you to leverage the power of Bootstrap's CSS framework alongside React components. There are several ways to use Bootstrap with React:</p>
      <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>Using Bootstrap CSS and React Components:</strong>
          <ol>
              <li><strong>CDN Link:</strong></li>
              <li>Include Bootstrap's CSS via a CDN link in the HTML file.</li>
              <li>Use Bootstrap classes directly in your React components.</li>
              <p>Let's go to our <strong>index.html</strong> file in the <strong>public</strong> folder as follows:</p>
              <strong>Installation:</strong>
              <li> <img class="img-fluid mb-4" src={bootstrapReact} alt="react" /></li>
              <p>This makes the Bootstrap class globally available to the project and we can use it as follows:</p>
              <CopyBlock
                        language={"react"}
                        text={code1} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />                </ol>
          </li>
           <li class="list-group-item"><strong>Bootstrap npm Package:</strong>
          <ol>
              <li>Install the Bootstrap npm package.</li>
              <li>Import Bootstrap CSS into your project and use Bootstrap classes in React components.</li>
              <CopyBlock
                        language={"react"}
                        text={code2} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />    

                      <br/>                
 <CopyBlock
                        language={"react"}
                        text={code3} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />                </ol>
          </li>
          <li  class="list-group-item"><strong>Using React Bootstrap:</strong>
          <ol>
              <li>React Bootstrap is a library that provides React components for Bootstrap 5. It allows you to use Bootstrap components as React components directly, offering enhanced functionality and interaction. You can check out the documentation here <strong class="text-primary">https://react-bootstrap.netlify.app/</strong></li>
              <strong>Installation:</strong>
              <CopyBlock
                        language={"react"}
                        text={code4} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      /> 
                      <br/>                   
 <CopyBlock
                        language={"react"}
                        text={code5} 
                        showLineNumbers={lineNumbers} 
                        theme={dracula} 
                        wrapLines={true}
                        codeBlock
                      />                </ol>
          </li>
      </ol>
      <h3><strong>Summary</strong></h3>
      <p>Using React Bootstrap offers the advantage of pre-built React components that adhere to Bootstrap's design principles, making it easier to create responsive and interactive UIs within React applications.</p>
      <p>Choose the method that best suits your project requirements and familiarity with Bootstrap or React Bootstrap. Both approaches allow you to integrate Bootstrap styles and components into your React application effectively.</p>
  
 
    </div>

      </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default ReactLesson12
  